export default __webpack_public_path__ + "static/media/proximanova-semibold.f22b5980.otf";